var map = {
	"./apple.png": 1099,
	"./apple.webp": 9018,
	"./fortnite.png": 4893,
	"./fortnite.webp": 8084,
	"./google-play.png": 6233,
	"./google-play.webp": 4792,
	"./netflix.png": 8753,
	"./netflix.webp": 5514,
	"./nintendo-membership.png": 1547,
	"./nintendo-membership.webp": 1661,
	"./nintendo.png": 129,
	"./nintendo.webp": 1255,
	"./playstation.png": 2813,
	"./playstation.webp": 1826,
	"./pubg.png": 4642,
	"./pubg.webp": 9375,
	"./riot.png": 138,
	"./riot.webp": 9627,
	"./roblox.png": 537,
	"./roblox.webp": 1254,
	"./spotify.png": 5630,
	"./spotify.webp": 6751,
	"./steam.png": 3260,
	"./steam.webp": 267,
	"./xbox-game-pass.png": 7982,
	"./xbox-game-pass.webp": 5672,
	"./xbox.png": 7550,
	"./xbox.webp": 9387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6768;